import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'customer-header-options',
  template: `
    <ng-content></ng-content>
  `,
  styles: [''],
})
export class HeaderOptionsComponent<T> {
  @Input() secondary = false;
  @Input() value?: T;
  @Input() interactive = true;

  @Output() readonly valueChange = new EventEmitter<T>();
}
